import React, { useEffect, useState } from "react";
import CheckboxCustom from "../../../../features/CheckboxCustom";
import useFacility from "../../../../utils/hooks/useFacility";
import useNewsletterConfirmation from "../../NewsletterConfirmation/useNewsletterConfirmation";
import { useSelector } from "react-redux";
import { State } from "../../../store";

interface IProps {
  email?: string;
  onAllowMailingChange?: (value: boolean) => void;
}
const CheckBoxNewsletter: React.FC<IProps> = ({ email, onAllowMailingChange }) => {
  const [form, setForm] = useState({ mail: "", name: "", lastName: "", checkbox1: false, checkbox2: false });
  const facilityIds = useFacility();
  const { sendInvite } = useNewsletterConfirmation();
  const newsletterActive = useSelector((state: State) => state.config.configuration?.newsLetterActive);
  const privatePolicy = useSelector((state: State) => state.config.configuration?.regulaminList[0].file);
  const labelText = `Zaznaczając to pole, wyrażam zgodę na otrzymywanie newslettera drogą mailową. Rozumiem i akceptuję warunki <a target='_blank' href='${privatePolicy}'>polityki prywatności</a> dotyczące przetwarzania moich danych osobowych.`;

  useEffect(() => {
    if (form.checkbox1 === true && email) {
      setTimeout(() => {
        sendInvite(facilityIds, email);
      }, 2000);
    }
    //eslint-disable-next-line
  }, [email]);

  return (
    <React.Fragment>
      <div style={{ marginTop: "16px" }} className="flex-start-center">
        <h5>Dołącz do newslettera</h5>
      </div>

      {newsletterActive && (
        <CheckboxCustom
          value={form.checkbox1}
          setValue={(value) => {
            setForm({ ...form, checkbox1: value });
            if (onAllowMailingChange) {
              onAllowMailingChange(value);
            }
          }}
          label={labelText}
        />
      )}
    </React.Fragment>
  );
};

export default CheckBoxNewsletter;
